import * as Yup from 'yup';
import { REPORTING_DOCUMENTS } from '@/helpers/reporting';

const arrayValidation = (documents, doctype) =>
  Yup.array().min(documents.includes(doctype) ? 1 : 0);

export const VALIDATION_SCHEMA = (requiredDocuments = []) =>
  Yup.object().shape({
    balance_sheet: arrayValidation(requiredDocuments, REPORTING_DOCUMENTS.balance_sheet),
    pnl: arrayValidation(requiredDocuments, REPORTING_DOCUMENTS.pnl),
    cash_flow: Yup.array().min(0),
    bank_statement: arrayValidation(requiredDocuments, REPORTING_DOCUMENTS.bank_statement),
  });
